import { IModel, IViolation } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TypeFormat } from 'app/model/dataset/type-format';

import { sanitizeAndFormatString } from 'app/shared/utils/string.util';
import { Owned } from 'app/model/base/named';

@Metamodel.model({})
export class FileFormat extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_FileFormatType,
        constraint: {
            validator: FileFormat.validateFormat
        }
    })
    // eslint-disable-next-line
    public type: string;

    /**
     * Only used by copy wizard
     */
    public autoDetected: boolean;

    @Metamodel.attribute({
        type: FileFormat.referTypeTypeFormat
    })
    public typeFormat?: TypeFormat;
    private static referTypeTypeFormat(): IModel {
        return TypeFormat.MODEL;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validateFormat(owner: any, value: any): IViolation[] | undefined {
        if (owner?.concept?.constructor != null) {
            const allowedFormats: string[] = ['TextFormat', 'AvroFormat', 'JsonFormat', 'OrcFormat', 'ParquetFormat', 'NoFormat'];
            if (!allowedFormats.includes(value)) {
                return [{
                    context: owner,
                    message: () => sanitizeAndFormatString(stringResources.AllowedValidatorMessage, Metamodel.modelOf(owner.named).display[0],
                        stringResources.ModelName_FileFormatType, value, allowedFormats.toString())
                }];
            }
        }
        return undefined;
    }
}
